module.exports = __webpack_public_path__ + "media/images/theme/isc/logo-small-0a8e0bb4fca9e04710a6aa4c946bf78a.png";